import React, { useRef, useEffect, useState } from "react";
import {
  ProjectWrapper,
  SectionEighteenWrapper,
  SectionEightWrapper,
  SectionElevanWrapper,
  SectionFifteenWrapper,
  SectionFiveWrapper,
  SectionFourteenWrapper,
  SectionFourWrapper,

  SectionOneWrapper,
  SectionSeventeenWrapper,
  SectionSevenWrapper,
  SectionSixteenWrapper,
  SectionSixWrapper,

  SectionThirteenWrapper,
  SectionThreeWrapper,
  SectionTwelveWrapper,
  SectionTwoWrapper,
  SliderTracker,
} from "./styled";

import { Box, Grid, Theme, Typography, Dialog } from "@mui/material";
import Pharma1 from "../../Assets/images/pharma1.png";
import Pharma2 from "../../Assets/images/pharma2.png";
import Pharma3 from "../../Assets/images/pharma3.png";

import ImpactSection from "./ImpactSection";

import PharmaInfo from "../../Assets/images/PharmaInfo.png";
import PharmaIdea from "../../Assets/images/pharmaIdea.png";

import Slider1 from "../../Assets/images/Slider1.png";
import Slider2 from "../../Assets/images/Slider2.png";
import Slider3 from "../../Assets/images/Slider3.png";
import Slider4 from "../../Assets/images/Slider4.png";
import LastSlider1 from "../../Assets/images/LastSlider1.png";
import LastSlider2 from "../../Assets/images/LastSlider2.png";
import LastSlider3 from "../../Assets/images/LastSlider3.png";
import LastSlider4 from "../../Assets/images/LastSlider4.png";
import User1 from "../../Assets/images/user1.png";
import User2 from "../../Assets/images/user2.png";
import Image1 from "../../Assets/images/Project1last/Image1.png";
import Image2 from "../../Assets/images/Project1last/Image2.png";
import Image3 from "../../Assets/images/Project1last/Image3.png";
import Image4 from "../../Assets/images/Project1last/Image4.png";
import Image5 from "../../Assets/images/Project1last/Image5.png";
import Image6 from "../../Assets/images/Project1last/Image6.png";
import Image7 from "../../Assets/images/Project1last/Image7.png";
import Image8 from "../../Assets/images/Project1last/Image8.png";
import Image9 from "../../Assets/images/Project1last/Image9.png";
import Image10 from "../../Assets/images/Project1last/Image10.png";
import Image11 from "../../Assets/images/Project1last/Image11.png";
import Image12 from "../../Assets/images/Project1last/Image12.png";
import Image13 from "../../Assets/images/Project1last/Image13.png";
import Old1 from "../../Assets/images/old1.png";
import Old2 from "../../Assets/images/old2.png";
import Old3 from "../../Assets/images/old3.png";
import Old4 from "../../Assets/images/old4.png";
import Old5 from "../../Assets/images/old5.png";

import Figma from "../../Assets/images/Figma.png";
import Pharma1Video from "../../Assets/images/Pharma1.mp4";
import Pharma2Video from "../../Assets/images/Pharma2.mp4";
import Pharma3GIF from "../../Assets/images/Pharma3GIF.gif";

import { AnimationOnScroll } from "react-animation-on-scroll";
import BulbIcon from "../../Assets/Icons/BulbIcon";
import HandDownIcon from "../../Assets/Icons/HandDownIcon";
import { ChevronLeft, ChevronRight, East } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import Slider from "react-slick";

import DrawLine from "../../Assets/Icons/DrawLine";
import debounce from "../../Helper/debounce";
import Line1 from "../../Assets/Icons/Line1";
import Line2 from "../../Assets/Icons/Line2";
import { scrollTrigger } from "../../Helper/scrollAnimation";
import LongLine from "../../Assets/Icons/LongLine";
import ToolTipIcons from "../../Assets/Icons/ToolTipIcons";
import Marquee from "react-fast-marquee";
import CircleIcon from "../../Assets/Icons/CircleIcon";
import TriangleIcon from "../../Assets/Icons/TriangleIcon";
import SqaureIcon from "../../Assets/Icons/SqaureIcon";
import SadIcon from "../../Assets/Icons/SadIcon";
import Prisma from "../../Assets/Icons/Prisma";
import ArchiImage from "../../Assets/images/archi.png";
import BefImage from "../../Assets/images/bef.png";
import AftImage from "../../Assets/images/aft.png";
import withAuth from "../../HOC/withAuth";

const ItrationText1 = [
  "\u201CI love that the KPIs are on the homescreen\u201D",
  
];
const ItrationText2 = [
  "It did not take into account the way data is entered for various KPIs (this one just has one KPI per region, while there could be multiple KPIs for the same region).",
];
const ItrationText3 = [
  "\u201COnly 2-3 people have the authority to use Freeze\u201D (which meant that prominence could be reduced on the Dashboard, and something more important can take its place)",
];
const ItrationText4 = [
  "\u201CThe table was cluttered\u201D (Opportunity for us to figure out if the columns can be modified)",
];

const Project = () => {
  const { pathname } = useLocation();
  const IterationSection = useRef<any>();
  const [isPlaying, setIsPlaying] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [zoomedImage, setZoomedImage] = useState<string | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentSlideFromLastSlider, setCurrentSlideFromLastSlider] = useState({
    currentIndex: 0,
    prevIndex: 0,
  });
  const maxLength = useRef<number>(0);
  const maxLengthLastSlider = useRef<number>(0);
  const [splitPct, setSplitPct] = useState(50);
  const compareRef = useRef<HTMLDivElement>(null);
  const debounceTest = useRef<any>();
  const debounceTestLastSlider = useRef<any>();
  const SliderRef = useRef<any>();
  const SliderParentRef = useRef<any>();

  // Images array for keyboard navigation
  const images = [Pharma1, Pharma2, Image2, Image4];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://t.contentsquare.net/uxa/bb781a00c0c07.js";
    script.async = true;
    document.head.appendChild(script);
  
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  

  // Keyboard navigation for image zoom
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!zoomedImage) return;

      if (event.key === "ArrowLeft") {
        event.preventDefault();
        const newIndex =
          currentImageIndex > 0 ? currentImageIndex - 1 : images.length - 1;
        setCurrentImageIndex(newIndex);
        setZoomedImage(images[newIndex]);
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        const newIndex =
          currentImageIndex < images.length - 1 ? currentImageIndex + 1 : 0;
        setCurrentImageIndex(newIndex);
        setZoomedImage(images[newIndex]);
      } else if (event.key === "Escape") {
        setZoomedImage(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [zoomedImage, currentImageIndex, images]);

  // Replaced with manual navigation functions
  const handleSliderNext = () => {
    if (currentSlide < 3) {
      setCurrentSlide((prev) => {
        const next = prev + 1;
        if (SliderRef.current) {
          SliderRef.current.slickGoTo(next);
        }
        return next;
      });
    }
  };

  const handleSliderPrev = () => {
    if (currentSlide > 0) {
      setCurrentSlide((prev) => {
        const next = prev - 1;
        if (SliderRef.current) {
          SliderRef.current.slickGoTo(next);
        }
        return next;
      });
    }
  };

  // Replaced with manual navigation functions
  const handleLastSliderNext = () => {
    if (currentSlideFromLastSlider.currentIndex < 4) {
      setCurrentSlideFromLastSlider((prev) => ({
        prevIndex: prev.currentIndex,
        currentIndex: prev.currentIndex + 1,
      }));
    }
  };

  const handleLastSliderPrev = () => {
    if (currentSlideFromLastSlider.currentIndex > 0) {
      setCurrentSlideFromLastSlider((prev) => ({
        prevIndex: prev.currentIndex,
        currentIndex: prev.currentIndex - 1,
      }));
    }
  };

  // Keep the original scroll trigger
  useEffect(() => {
    window.addEventListener("scroll", (e) => {
      scrollTrigger(".lineAnimation");
    });
  }, []);

  return (
    <ProjectWrapper>
      <Box
        sx={{
          position: "fixed",
          width: "1px",
          height: "1px",
          background: (theme: Theme) => theme.palette.primary.main,
          top: 0,
          zIndex: 999999999999,
          left: 0,
          borderRadius: "100%",
          animation: "animateCircle1 0.5s",
          animationIterationCount: 1,
          "@keyframes animateCircle1": {
            from: {
              transform: "scale(4000)",
            },
            to: { transform: "scale(0)" },
          },
        }}
      ></Box>
      <SectionOneWrapper>
        <Typography variant="h1">JOHNSON & JOHNSON</Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { sm: "row", xs: "column" },
            "& p": {
              fontWeight: 500,
              fontSize: { md: "28px", xs: "22px" },
            },
          }}
        >
          <Typography>ENTERPRISE SUPPLY CHAIN</Typography>
        </Box>
      </SectionOneWrapper>

      <SectionTwoWrapper>
        <Box
          sx={{
            overflowX: "auto",
            overflowY: "hidden",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "max-content",
              "& img": {
                width: { lg: "832px", md: "700px", sm: "600px", xs: "402px" },
                height: "auto",
                boxShadow: "4px 0px 20px 0px #66666640",
                borderRadius: "12px",
                cursor: "pointer",
              },
              "& > div": {
                mx: 1.75,
              },
            }}
          >
            <Box
              onClick={() => {
                setZoomedImage(Pharma1);
                setCurrentImageIndex(0);
              }}
            >
              <img src={Pharma1} alt="No Banner" />
            </Box>
            <Box
              onClick={() => {
                setZoomedImage(Pharma2);
                setCurrentImageIndex(1);
              }}
            >
              <img src={Pharma2} alt="No Banner" />
            </Box>
            <Box
              onClick={() => {
                setZoomedImage(Image2);
                setCurrentImageIndex(2);
              }}
            >
              <img src={Image2} alt="No Banner" />
            </Box>
            <Box
              onClick={() => {
                setZoomedImage(Image4);
                setCurrentImageIndex(3);
              }}
            >
              <img src={Image4} alt="No Banner" />
            </Box>
          </Box>
        </Box>

        {/* Image Zoom Modal */}
        <Dialog
          open={!!zoomedImage}
          onClose={() => setZoomedImage(null)}
          maxWidth={false}
          PaperProps={{
            sx: {
              backgroundColor: "transparent",
              boxShadow: "none",
              overflow: "hidden",
            },
          }}
          sx={{
            "& .MuiBackdrop-root": {
              backgroundColor: "rgba(0, 0, 0, 0.8)",
            },
          }}
        >
          <Box
            onClick={() => setZoomedImage(null)}
            sx={{
              position: "relative",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              outline: "none",
              "& img": {
                maxWidth: "90vw",
                maxHeight: "90vh",
                width: "auto",
                height: "auto",
              },
            }}
            tabIndex={0}
          >
            {zoomedImage && <img src={zoomedImage} alt="Zoomed" />}
          </Box>
        </Dialog>
      </SectionTwoWrapper>

      <SectionThreeWrapper id="section1">
        <Box>
          <Typography
            variant="h3"
            sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 600 }}
          >
            The tool 400+ analysts depend on - and why it was breaking
          </Typography>

          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            Prism is J&J’s internal tool for 400+ supply chain analysts to log
            KPI data like fill rate, lead time, etc. that directly drives
            global planning decisions.
          </Typography>
          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            Before the redesign, the system had no concept of data ownership.
            Any analyst could overwrite any other analyst’s data, errors went
            unnoticed, and corrupted numbers affected planning cycles worth
            millions.
          </Typography>
          <Box
            sx={{
              py: 3.5,
              px: 4,
              mt: 4,
              background: (theme: Theme) => theme.palette.secondary.main,
            }}
          >
            <Typography
              sx={{
                fontSize: { md: "28px", xs: "22px" },
                fontWeight: 600,
                lineHeight: "33.89px",
              }}
            >
              I led the redesign end-to-end — research, synthesis, concept
              testing, prototypes, usability testing — working cross-functionally
              with engineering, product, and business stakeholders to ship a
              role-based permission system that made entry faster, safer, and
              auditable.
            </Typography>
          </Box>

        </Box>
      </SectionThreeWrapper>

      <ImpactSection />

      <SectionThreeWrapper>
        <Box>
          <Typography
            variant="h3"
            sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 600 }}
          >
            How data actually moved through the system
          </Typography>
          <Box
            component="img"
            src={ArchiImage}
            alt="Data Architecture"
            sx={{
              mt: 4,
              width: "100%",
            }}
          />
          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 4 }}>
            Prism sits at the center of J&J's supply chain data pipeline.
            Source data lives in SAP, Kinaxis, Tableau exports, and Excel
            files. Analysts manually copy from these sources into Prism.
          </Typography>
          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            The system had no mechanism to detect when the wrong person touched
            the wrong number — or to stop the error before it reached a
            planning dashboard.
          </Typography>
        </Box>
      </SectionThreeWrapper>

      <SectionThreeWrapper>
        <Box>
          <Typography
            variant="h3"
            sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 600 }}
          >
            It looked like a speed problem. It wasn't.
          </Typography>

          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 3 }}>
            The system treated every analyst identically. No role
            differentiation, no concept of data ownership. An analyst in North
            America could overwrite an entry owned by someone in APAC, and
            neither person would know.
          </Typography>
          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            No confirmations, no change logs. On top of that, 7 levels of
            hierarchy meant 6+ clicks to reach data entry, and key views were
            buried behind inaccessible icons.
          </Typography>
          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            So I started with understanding who the users actually are and what
            each one should be allowed to do.
          </Typography>

          <Box
            sx={{
              py: 3.5,
              px: 4,
              mt: 4,
              background: (theme: Theme) => theme.palette.secondary.main,
            }}
          >
            <Typography
              sx={{
                fontSize: { md: "28px", xs: "22px" },
                fontWeight: 600,
                lineHeight: "33.89px",
              }}
            >
              Three users, three levels of access
            </Typography>
            <Typography
              sx={{
                fontSize: { md: "22px", sm: "18px" },
                mt: 2.5,
              }}
            >
              Research surfaced three distinct roles, each needing a
              fundamentally different relationship with the data:
            </Typography>
            <Typography
              sx={{
                fontSize: { md: "22px", sm: "18px" },
                mt: 2.5,
              }}
            >
              <strong>Data Owner</strong> — Enters weekly KPI data. Should only
              see and edit their own entries.
              <br /><br />
              <strong>Data Lead</strong> — Monitors submission status across a
              region. Sees everything, edits occasionally.
              <br /><br />
              <strong>View-Only</strong> — Consumes data for planning decisions.
              Full read access, zero edit capability.
            </Typography>
            <Typography
              sx={{
                fontSize: { md: "22px", sm: "18px" },
                mt: 2.5,
              }}
            >
              These roles became the foundation of every design decision that
              followed.
            </Typography>
          </Box>
        </Box>
      </SectionThreeWrapper>

      <SectionThreeWrapper>
        <Typography
          variant="h3"
          sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 600 }}
        >
          What I found when I watched people work
        </Typography>
        <Box
          sx={{
            py: 3.5,
            px: 4,
            mt: 4,
            background: (theme: Theme) => theme.palette.secondary.main,
          }}
        >
          <Typography
            sx={{
              fontSize: { md: "28px", xs: "22px" },
              fontWeight: 600,
              lineHeight: "33.89px",
            }}
          >
            4 interviews, contextual observation of their workflow,
            and a card sort.
          </Typography>
        </Box>

        <Box
          component="img"
          src={PharmaInfo}
          alt="Research findings"
          sx={{
            mt: 4,
            width: "100%",
          }}
        />

        <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 5 }}>
          Findings clustered into three themes:
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: 3,
            mt: 4,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box
            sx={{
              flex: 1,
              border: "3px solid",
              borderColor: "primary.main",
              borderRadius: 0,
              p: 3,
            }}
          >
            <Typography
              sx={{
                fontSize: { md: "22px", xs: "18px" },
                fontWeight: 700,
                color: "primary.main",
              }}
            >
              Ownership
            </Typography>
            <Typography sx={{ fontSize: { md: "18px", xs: "16px" }, mt: 1 }}>
              No concept of who was responsible for what
            </Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              border: "3px solid",
              borderColor: "primary.main",
              borderRadius: 0,
              p: 3,
            }}
          >
            <Typography
              sx={{
                fontSize: { md: "22px", xs: "18px" },
                fontWeight: 700,
                color: "primary.main",
              }}
            >
              Structure
            </Typography>
            <Typography sx={{ fontSize: { md: "18px", xs: "16px" }, mt: 1 }}>
              7-level hierarchy, buried views
            </Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              border: "3px solid",
              borderColor: "primary.main",
              borderRadius: 0,
              p: 3,
            }}
          >
            <Typography
              sx={{
                fontSize: { md: "22px", xs: "18px" },
                fontWeight: 700,
                color: "primary.main",
              }}
            >
              Bulk Operations
            </Typography>
            <Typography sx={{ fontSize: { md: "18px", xs: "16px" }, mt: 1 }}>
              Upload tied to individual hierarchy levels
            </Typography>
          </Box>
        </Box>
      </SectionThreeWrapper>
      <SectionSixWrapper>
        <Typography
          variant="h3"
          sx={{
            fontSize: { md: "40px", sm: "32px", xs: "28px" },
            fontWeight: 700,
            ml: { md: 7.5, sm: 5, xs: 2 },
            fontFamily: "Mohave",
            fontStyle: "italic",
          }}
        >
          FOR REFERENCE - OLD APPLICATION SCREENS
          <br></br>
        </Typography>

        <Box
          sx={{
            ml: 3,
            mt: 3,
            "& p": {
              px: { md: 3, xs: 1.5 },
              py: { md: 2, xs: 1 },
              position: "absolute",
              bottom: 0,
              left: "0",
              fontSize: { md: "20px", xs: "14px" },
              zIndex: 1,
              background: (theme: Theme) => theme.palette.secondary.main,
              fontWeight: 600,
            },
            "& img": {
              boxShadow: "4px 0px 20px 0px #66666640",
              borderRadius: "12px",
              width: "auto",
              maxHeight: { lg: "470px", md: "300px", sm: "250px", xs: "150px" },
            },
            // Enhanced arrow styling with bigger size and proper positioning
            "& .slick-arrow": {
              width: "60px !important",
              height: "60px !important",
              borderRadius: "50%",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              border: "2px solid #fff",
              display: "flex !important",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2,
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.9)",
              },
              "&:before": {
                display: "none !important",
              },
            },
            "& .slick-prev": {
              left: "20px !important", // Safe distance from left edge and side nav
            },
            "& .slick-next": {
              right: "20px !important", // Safe distance from right edge
            },
            // Style the chevron icons
            "& .slick-arrow svg": {
              fontSize: "32px !important",
              color: "#fff",
            },
          }}
        >
          <Slider
            {...{
              infinite: true,
              nextArrow: (
                <Box
                  sx={{
                    display: "flex !important",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <ChevronRight sx={{ fontSize: "32px !important" }} />
                </Box>
              ),
              prevArrow: (
                <Box
                  sx={{
                    display: "flex !important",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <ChevronLeft sx={{ fontSize: "32px !important" }} />
                </Box>
              ),
              arrows: true,
              adaptiveHeight: true,
              variableWidth: true,
              draggable: true,
              speed: 500,
              autoplay: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            }}
          >
            <Box sx={{ position: "relative", mx: 1.5 }}>
              <img src={Old1} alt="No Info" />
              <Typography sx={{ borderBottomLeftRadius: "12px" }}>
                Data Entry (tiny pencil icon)
              </Typography>
            </Box>

            <Box sx={{ position: "relative", mx: 1.5 }}>
              <img src={Old2} alt="No Info" />
              <Typography sx={{ borderBottomLeftRadius: "12px" }}>
                Navigation
              </Typography>
            </Box>

            <Box sx={{ position: "relative", mx: 1.5 }}>
              <img src={Old3} alt="No Info" />
              <Typography sx={{ borderBottomLeftRadius: "12px" }}>
                Bulk Upload
              </Typography>
            </Box>

            <Box sx={{ position: "relative", mx: 1.5 }}>
              <img src={Old4} alt="No Info" />
              <Typography sx={{ borderBottomLeftRadius: "12px" }}>
                Scorecard
              </Typography>
            </Box>

            <Box sx={{ position: "relative", mx: 1.5 }}>
              <img src={Old5} alt="No Info" />
              <Typography sx={{ borderBottomLeftRadius: "12px" }}>
                KPI Overview
              </Typography>
            </Box>
          </Slider>
        </Box>
      </SectionSixWrapper>
      <SectionThreeWrapper>
        <Box>
          <Typography
            variant="h3"
            sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 600 }}
          >
            The structure had to change — not just the interface
          </Typography>
          <Box sx={{ mt: 4, width: "100%" }}>
            <Box
              ref={compareRef}
              sx={{ position: "relative", overflow: "hidden", cursor: "ew-resize", userSelect: "none", border: "3px solid #0021F5" }}
              onMouseMove={(e: React.MouseEvent) => {
                const rect = compareRef.current?.getBoundingClientRect();
                if (!rect) return;
                const x = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
                setSplitPct((x / rect.width) * 100);
              }}
              onTouchMove={(e: React.TouchEvent) => {
                const rect = compareRef.current?.getBoundingClientRect();
                if (!rect) return;
                const x = Math.max(0, Math.min(e.touches[0].clientX - rect.left, rect.width));
                setSplitPct((x / rect.width) * 100);
              }}
            >
              <img src={AftImage} alt="After" style={{ width: "100%", display: "block" }} />
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  width: `${splitPct}%`,
                  overflow: "hidden",
                  background: "#fff",
                }}
              >
                <img
                  src={BefImage}
                  alt="Before"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: compareRef.current ? `${compareRef.current.getBoundingClientRect().width}px` : "100%",
                    height: "100%",
                    objectFit: "contain",
                    objectPosition: "left top",
                    display: "block",
                  }}
                />
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: `${splitPct}%`,
                  transform: "translateX(-50%)",
                  width: "3px",
                  height: "100%",
                  background: "#0021F5",
                  zIndex: 2,
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: `${splitPct}%`,
                  transform: "translate(-50%, -50%)",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "#0021F5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 3,
                  color: "#fff",
                  fontSize: "18px",
                  fontWeight: 700,
                }}
              >
                ⇔
              </Box>
            </Box>
            <Typography
              sx={{
                fontSize: { md: "18px", xs: "14px" },
                fontWeight: 600,
                mt: 2,
                textAlign: "center",
                transition: "opacity 0.2s",
              }}
            >
              {splitPct > 50 ? "Before: 7 levels. Same long path for every user." : "After: 2 levels. Role-aware entry points."}
            </Typography>
          </Box>
        </Box>
      </SectionThreeWrapper>

      <SectionElevanWrapper>
        <Typography
          variant="h3"
          sx={{
            fontSize: { md: "40px", sm: "32px", xs: "28px" },
            fontWeight: 700,
            ml: { lg: 7.5, sm: 5, xs: 2 },
            fontFamily: "Mohave",
            fontStyle: "italic",
            width: "fit-content",
            // borderBottom: "4px solid",
          }}
        >
          ITERATIONS I RULED OUT
        </Typography>

       
        <Box ref={SliderParentRef} sx={{ position: "relative" }}>
          {/* Both arrows in a container at bottom right */}
          <Box
            sx={{
              position: "absolute",
              bottom: { md: 40, xs: 20 },
              right: { md: 40, xs: 20 },
              zIndex: 10,
              display: "flex",
              gap: 1.5,
            }}
          >
            <Box
              onClick={handleSliderPrev}
              sx={{
                cursor: "pointer",
                width: 48,
                height: 48,
                borderRadius: "50%",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s ease",
                opacity: currentSlide === 0 ? 0.3 : 1,
                pointerEvents: currentSlide === 0 ? "none" : "auto",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.9)",
                  transform: "scale(1.1)",
                },
              }}
            >
              <ChevronLeft sx={{ color: "#F7F5F0", fontSize: 32 }} />
            </Box>

            <Box
              onClick={handleSliderNext}
              sx={{
                cursor: "pointer",
                width: 48,
                height: 48,
                borderRadius: "50%",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s ease",
                opacity: currentSlide === 3 ? 0.3 : 1,
                pointerEvents: currentSlide === 3 ? "none" : "auto",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.9)",
                  transform: "scale(1.1)",
                },
              }}
            >
              <ChevronRight sx={{ color: "#F7F5F0", fontSize: 32 }} />
            </Box>
          </Box>

          <Slider
            ref={(c) => (SliderRef.current = c)}
            {...{
              dots: true,
              infinite: false, // Changed from true
              arrows: false, // Disabled default arrows
              speed: 250,
              slidesToShow: 1,
              slidesToScroll: 1,
              beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex), // Added
            }}
          >
            <Box>
              <Grid
                container
                sx={{ mt: 4 }}
                alignItems="flex-start"
                position="relative"
              >
                <Grid
                  item
                  lg={8.5}
                  md={8}
                  sx={{
                    p: 3,
                    "& img": {
                      width: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "4px 0px 20px 0px #66666640",
                    },
                  }}
                >
                  <img src={Slider1} alt="No content" />
                </Grid>
                <Grid
                  item
                  lg={3.5}
                  md={4}
                  xs={12}
                  sx={{
                    textAlign: { md: "left", xs: "left" },
                    mx: { md: 0, xs: 5 },
                  }}
                >
                  <Box
                    sx={{
                      display: { md: "block", xs: "none" },
                      position: "absolute",
                      transform: "translate(-20px,50px)",
                    }}
                  ></Box>
                  <Box
                    sx={{
                      py: 2.25,
                      px: 3,
                      mt: { md: 10 },
                      width: { md: "100%", xs: "80%" },
                      // mx: { md: 0, xs: "auto" },
                      background: (theme: Theme) =>
                        theme.palette.secondary.main,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { lg: "20px", xs: "16px" },
                        fontWeight: 600,
                        color: "#000",
                        textAlign: "center",
                      }}
                    >
                      Excerpts from the user feedback
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      "& p": {
                        fontFamily: "Caveat",
                        fontSize: { lg: "24px", sm: "20px", xs: "15px" },
                      },
                    }}
                  >
                    {ItrationText1.map((item, index) => {
                      return (
                        <Typography sx={{ mt: { lg: 3.5, xs: 1 } }}>
                          {item}
                        </Typography>
                      );
                    })}
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Grid
                container
                sx={{ mt: 4 }}
                alignItems="flex-start"
                position="relative"
              >
                <Grid
                  item
                  lg={8.5}
                  md={8}
                  sx={{
                    p: 3,
                    "& img": {
                      width: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "4px 0px 20px 0px #66666640",
                    },
                  }}
                >
                  <img src={Slider2} alt="No content" />
                </Grid>
                <Grid
                  item
                  lg={3.5}
                  md={4}
                  xs={12}
                  sx={{
                    textAlign: { md: "left", xs: "left" },
                    mx: { md: 0, xs: 5 },
                  }}
                >
                  <Box
                    sx={{
                      display: { md: "block", xs: "none" },
                      position: "absolute",
                      transform: "translate(-20px,50px)",
                    }}
                  ></Box>
                  <Box
                    sx={{
                      py: 2.25,
                      px: 3,
                      mt: { md: 10 },
                      width: { md: "100%", xs: "80%" },
                      // mx: { md: 0, xs: "auto" },
                      background: (theme: Theme) =>
                        theme.palette.secondary.main,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { lg: "24px", xs: "20px" },
                        fontWeight: 600,
                        color: "#000",
                        textAlign: "center",
                      }}
                    >
                      Discarded - failed heuristic review.{" "}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      "& p": {
                        fontFamily: "Caveat",
                        fontSize: { lg: "24px", sm: "20px", xs: "15px" },
                      },
                    }}
                  >
                    {ItrationText2.map((item, index) => {
                      return (
                        <Typography sx={{ mt: { lg: 3.5, xs: 1 } }}>
                          {item}
                        </Typography>
                      );
                    })}
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Grid
                container
                sx={{ mt: 4 }}
                alignItems="flex-start"
                position="relative"
              >
                <Grid
                  item
                  lg={8.5}
                  md={8}
                  sx={{
                    p: 3,
                    "& img": {
                      width: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "4px 0px 20px 0px #66666640",
                    },
                  }}
                >
                  <img src={Slider3} alt="No content" />
                </Grid>
                <Grid
                  item
                  lg={3.5}
                  md={4}
                  xs={12}
                  sx={{
                    textAlign: { md: "left", xs: "left" },
                    mx: { md: 0, xs: 5 },
                  }}
                >
                  <Box
                    sx={{
                      display: { md: "block", xs: "none" },
                      position: "absolute",
                      transform: "translate(-20px,50px)",
                    }}
                  ></Box>
                  <Box
                    sx={{
                      py: 2.25,
                      px: 3,
                      mt: { md: 10 },
                      width: { md: "100%", xs: "80%" },
                      // mx: { md: 0, xs: "auto" },
                      background: (theme: Theme) =>
                        theme.palette.secondary.main,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { lg: "20px", xs: "16px" },
                        fontWeight: 600,
                        color: "#000",
                        textAlign: "center",
                      }}
                    >
                      Excerpts from the user feedback
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      "& p": {
                        fontFamily: "Caveat",
                        fontSize: { lg: "22px", sm: "18px", xs: "15px" },
                      },
                    }}
                  >
                    {ItrationText3.map((item, index) => {
                      return (
                        <Typography
                          sx={{ mt: 3.5 }}
                          // className={index === currentSlide ? "active" : ""}
                        >
                          {item}
                        </Typography>
                      );
                    })}
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Grid
                container
                sx={{ mt: 4 }}
                alignItems="flex-start"
                position="relative"
              >
                <Grid
                  item
                  lg={8.5}
                  md={8}
                  sx={{
                    p: 3,
                    "& img": {
                      width: "100%",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "4px 0px 20px 0px #66666640",
                    },
                  }}
                >
                  <img src={Slider4} alt="No content" />
                </Grid>
                <Grid
                  item
                  lg={3.5}
                  md={4}
                  xs={12}
                  sx={{
                    textAlign: { md: "left", xs: "left" },
                    mx: { md: 0, xs: 5 },
                  }}
                >
                  <Box
                    sx={{
                      display: { md: "block", xs: "none" },
                      position: "absolute",
                      transform: "translate(-20px,50px)",
                    }}
                  ></Box>
                  <Box
                    sx={{
                      py: 2.25,
                      px: 3,
                      mt: { md: 10 },
                      width: { md: "100%", xs: "80%" },
                      // mx: { md: 0, xs: "auto" },
                      background: (theme: Theme) =>
                        theme.palette.secondary.main,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { lg: "20px", xs: "16px" },
                        fontWeight: 600,
                        color: "#000",
                        textAlign: "center",
                      }}
                    >
                      Excerpts from the user feedback
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      "& p": {
                        fontFamily: "Caveat",
                        fontSize: { lg: "22px", sm: "18px", xs: "15px" },
                      },
                    }}
                  >
                    {ItrationText4.map((item, index) => {
                      return <Typography sx={{ mt: 3.5 }}>{item}</Typography>;
                    })}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Slider>
        </Box>
      </SectionElevanWrapper>
      <SectionTwelveWrapper id="section3">
        <Typography
          variant="h3"
          sx={{
            fontSize: { md: "40px", sm: "32px", xs: "28px" },
            fontWeight: 700,
            fontFamily: "Mohave",
            fontStyle: "italic",
            width: "fit-content",
            // borderBottom: "4px solid",
          }}
        >
          FINAL DESIGN VALIDATED THROUGH USABILITY TESTING
        </Typography>
        <Box sx={{ mt: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { md: "28px", xs: "22px" },
              fontWeight: 600,
              lineHeight: "33.89px",
            }}
          >
            Introducing....
          </Typography>
          <Typography
            variant="h3"
            sx={{
              mt: 2,
              fontSize: { md: "40px", sm: "32px", xs: "28px" },
              fontWeight: 700,
              fontFamily: "Mohave",
              fontStyle: "italic",
              width: "fit-content",
            }}
          >
            ROLE-BASED DATA UPLOAD
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 7.5,
            "& img": {
              width: "100%",
              height: "auto",
              borderRadius: "12px",
              boxShadow: "4px 0px 20px 0px #66666640",
            },
          }}
        >
          <img src={Pharma1} alt="No content" />
        </Box>
        <Box
          sx={{
            mt: 7.5,
            ml: { md: 3, xs: 1 },
            width: "100%",
            maxWidth: "1000px",
            "& p": {
              fontSize: {
                md: "22px !important",
                sm: "18px !important",
                xs: "15px !important",
              },
              color: "#000",
              mt: 5,
            },
          }}
        >
        </Box>
      </SectionTwelveWrapper>
      <SectionThirteenWrapper>
        {/* Neon Green Rectangle 1 */}
        <Box
          sx={{
            position: "absolute",
            top: { lg: "22%", sm: "10%" },
            left: {
              lg: "calc(50% - 300px)",
              md: "calc(50% - 250px)",
              sm: "calc(50% - 300px)",
            },
            width: { lg: "450px", sm: "350px" },
            transform: { md: "translateX(-50%)" },
            display: { sm: "block", xs: "none" },
            p: 3,
            backgroundColor: "#ADFF00",
          }}
        >
          <Typography
            sx={{
              fontFamily: "DM Sans, sans-serif",
              fontSize: { lg: "18px", sm: "16px" },
              fontWeight: 500,
              color: "#000",
              lineHeight: 1.4,
            }}
          >
            The tables shown are user-specific, meaning that no data owner would
            now be able to over-write somebody else's data
          </Typography>
        </Box>

        {/* Neon Green Rectangle 2 */}
        <Box
          sx={{
            position: "absolute",
            display: { sm: "block", xs: "none" },
            top: { md: "68%", sm: "56%" },
            left: {
              lg: "calc(50% - 300px)",
              md: "calc(50% - 250px)",
              sm: "calc(50% - 300px)",
            },
            width: { lg: "450px", sm: "350px" },
            transform: { md: "translateX(-50%)" },
            p: 3,
            backgroundColor: "#ADFF00",
          }}
        >
          <Typography
            sx={{
              fontFamily: "DM Sans, sans-serif",
              fontSize: { lg: "18px", sm: "16px" },
              fontWeight: 500,
              color: "#000",
              lineHeight: 1.4,
            }}
          >
            All assigned KPIs are now shown on a single screen, to enable easy
            data entry for multiple KPIs
          </Typography>
        </Box>

        <Box
          sx={{
            textAlign: { sm: "right", xs: "center" },
            transform: {
              lg: "translateX(290px)",
              md: "translateX(350px)",
              sm: "translateX(400px)",
            },
            "& img": {
              width: { lg: "950px", md: "850px", sm: "650px", xs: "90%" },
              height: "auto",
              borderRadius: "12px",
              boxShadow: "-4px 4px 20px 0px #66666640",
            },
          }}
        >
          <img src={Pharma1} alt="No Content" />
          <Box
            sx={{ display: { sm: "none", xs: "block" }, width: "90%", ml: 1 }}
          >
            {/* Mobile Neon Green Rectangles */}
            <Box
              sx={{
                p: 3,
                mb: 3,
                backgroundColor: "#ADFF00",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "DM Sans, sans-serif",
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#000",
                  lineHeight: 1.4,
                }}
              >
                The tables shown are user-specific, meaning that no data owner
                would now be able to over-write somebody else's data
              </Typography>
            </Box>

            <Box
              sx={{
                p: 3,
                backgroundColor: "#ADFF00",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "DM Sans, sans-serif",
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#000",
                  lineHeight: 1.4,
                }}
              >
                All assigned KPIs are now shown on a single screen, to enable
                easy data entry for multiple KPIs
              </Typography>
            </Box>
          </Box>
        </Box>
      </SectionThirteenWrapper>

      <SectionFourteenWrapper>
        {/* Neon Green Rectangle 3 */}
        <Box
          sx={{
            position: "absolute",
            display: { sm: "block", xs: "none" },
            top: { lg: "7%", md: 0 },
            left: {
              lg: "calc(50% + 325px)",
              md: "calc(50% + 250px)",
              sm: "calc(50% - 80px)",
            },
            transform: { md: "translateX(-50%)" },
            width: { lg: "450px", md: "350px", sm: "420px" },
            p: 3,
            backgroundColor: "#ADFF00",
          }}
        >
          <Typography
            sx={{
              fontFamily: "DM Sans, sans-serif",
              fontSize: { lg: "18px", md: "16px", sm: "14px" },
              fontWeight: 500,
              color: "#000",
              lineHeight: 1.4,
            }}
          >
            The editable columns (Num/Den/Actual) show up only when a user
            wishes to enter data (video shown below). This is to avoid
            unnecessary information on the homescreen
          </Typography>
        </Box>

        {/* Neon Green Rectangle 4 */}
        <Box
          sx={{
            position: "absolute",
            display: { sm: "block", xs: "none" },
            top: "51%",
            left: {
              lg: "calc(50% + 325px)",
              md: "calc(50% + 250px)",
              sm: "calc(50% - 80px)",
            },
            transform: { md: "translateX(-50%)" },
            width: { lg: "470px", md: "350px", sm: "420px" },
            p: 3,
            backgroundColor: "#ADFF00",
          }}
        >
          <Typography
            sx={{
              fontFamily: "DM Sans, sans-serif",
              fontSize: { lg: "18px", md: "16px", sm: "14px" },
              fontWeight: 500,
              color: "#000",
              lineHeight: 1.4,
            }}
          >
            Various states of Num/Den/Actual cells (x, white cell, coloured
            cell, no cell). These states have been introduced to denote
            different types of actions that can be taken on various KPIs
          </Typography>
        </Box>

        <Box
          sx={{
            textAlign: { sm: "left", xs: "center" },
            transform: {
              lg: "translateX(-272px)",
              md: "translateX(-370px)",
              sm: "translateX(-400px)",
            },
            "& img": {
              width: { lg: "950px", md: "850px", sm: "650px", xs: "90%" },
              height: "auto",
              borderRadius: "12px",
              boxShadow: "-4px 4px 20px 0px #66666640",
            },
          }}
        >
          <img src={Pharma3} alt="No Content" />
          <Box
            sx={{ display: { sm: "none", xs: "block" }, width: "90%", ml: 1 }}
          >
            {/* Mobile Neon Green Rectangles */}
            <Box
              sx={{
                p: 3,
                mb: 3,
                backgroundColor: "#ADFF00",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "DM Sans, sans-serif",
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#000",
                  lineHeight: 1.4,
                }}
              >
                The editable columns (Num/Den/Actual) show up only when a user
                wishes to enter data (video shown below). This is to avoid
                unnecessary information on the homescreen
              </Typography>
            </Box>

            <Box
              sx={{
                p: 3,
                backgroundColor: "#ADFF00",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "DM Sans, sans-serif",
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#000",
                  lineHeight: 1.4,
                }}
              >
                Various states of Num/Den/Actual cells (x, white cell, coloured
                cell, no cell). These states have been introduced to denote
                different types of actions that can be taken on various KPIs
              </Typography>
            </Box>
          </Box>
        </Box>
      </SectionFourteenWrapper>
      <Box
        sx={{
          mt: 12.5,
          width: "95%",
          mx: "auto",
          "& video": {
            maxWidth: "1536px",
            width: "100%",
            borderRadius: "12px",
            boxShadow: "4px 0px 20px 0px #66666640",
          },
        }}
      >
        <video src={Pharma2Video} autoPlay loop muted playsInline />
      </Box>

      <SectionFifteenWrapper>
        <Typography
          variant="h3"
          sx={{
            fontSize: { md: "40px", sm: "32px", xs: "28px" },
            fontWeight: 700,
            fontFamily: "Mohave",
            fontStyle: "italic",
            width: "fit-content",
            // borderBottom: "4px solid",
          }}
        >
          BULK UPLOAD
        </Typography>

        <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 7 }}>
          Bulk Upload is used to upload bulk of data in one go, without having
          to enter it one-by-one. Users have a single or a few source file(s),
          from where they copy data into an offline Excel template.
        </Typography>

        <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 5 }}>
          In the old application, it was a tedious and cumbersome process. It
          had several challenges -
        </Typography>

        <Box sx={{ display: "flex", alignItems: "flex-start", mt: 5 }}>
          <East
            sx={{
              "& *": {
                fill: "#ff0000",
              },
            }}
          />
          <Typography
            sx={{
              ml: 1,
              fontSize: { md: "22px", sm: "18px" },
              color: "#ff0000 !important",
              mt: "0 !important",
            }}
          >
            No ability to use Bulk Upload for multiple hierarchical levels at
            once
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "flex-start", mt: 5 }}>
          <East
            sx={{
              "& *": {
                fill: "#ff0000",
              },
            }}
          />
          <Typography
            sx={{
              ml: 1,
              fontSize: { md: "22px", sm: "18px" },
              color: "#ff0000 !important",
              mt: "0 !important",
            }}
          >
            Tedious to go to each level to be able to use Bulk Upload
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "flex-start", mt: 5 }}>
          <East
            sx={{
              "& *": {
                fill: "#ff0000",
              },
            }}
          />
          <Typography
            sx={{
              ml: 1,
              fontSize: { md: "22px", sm: "18px" },
              color: "#ff0000 !important",
              mt: "0 !important",
            }}
          >
            Not very convenient to maintain multiple Excel files for different
            data entry levels
          </Typography>
        </Box>

        <Box
          sx={{
            py: 3.5,
            px: 4,
            mt: 10,
            width: { md: "93%", xs: "100%" },
            background: (theme: Theme) => theme.palette.secondary.main,
          }}
        >
          <Typography
            sx={{
              fontSize: { md: "28px", xs: "22px" },
              fontWeight: 600,
              lineHeight: "33.89px",
              color: "#000",
            }}
          >
            Before redesigning bulk upload, I questioned whether the feature
            needed to exist at all. If analysts were copying data from SAP and
            Kinaxis anyway, why not sync it directly into Prism? After aligning
            with engineering, a direct integration wasn’t cost-justified at the
            time. That constraint led to the next-best solution: an online bulk
            upload that lived in the cloud instead of offline Excel templates.
          </Typography>
        </Box>
        <Box sx={{ mt: 10, width: "94%" }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { md: "28px", xs: "22px" },
              fontWeight: 600,
              lineHeight: "33.89px",
            }}
          >
            The next best solution....
          </Typography>

          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 7 }}>
            Online Bulk Upload. It is a common-for-all-KPIs template for
            uploading data in bulk, on cloud.
          </Typography>

          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 5 }}>
            <East
              sx={{
                "& *": {
                  fill: "#03a300",
                },
              }}
            />
            <Typography
              sx={{
                ml: 1,
                fontSize: { md: "22px", sm: "18px" },
                color: "#03a300 !important",
                mt: "0 !important",
              }}
            >
              Universal access to Bulk Upload, KPI-independent
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 5 }}>
            <East
              sx={{
                "& *": {
                  fill: "#03a300",
                },
              }}
            />
            <Typography
              sx={{
                ml: 1,
                fontSize: { md: "22px", sm: "18px" },
                color: "#03a300 !important",
                mt: "0 !important",
              }}
            >
              Adds the ability to bulk upload data for multiple KPIs at once
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 5 }}>
            <East
              sx={{
                "& *": {
                  fill: "#03a300",
                },
              }}
            />
            <Typography
              sx={{
                ml: 1,
                fontSize: { md: "22px", sm: "18px" },
                color: "#03a300 !important",
                mt: "0 !important",
              }}
            >
              In order to maintain familiarity, Online Bulk Upload still has
              basic Excel features like multi-cell selection, copy/paste,
              column-level filter
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 5 }}>
            <East
              sx={{
                "& *": {
                  fill: "#03a300",
                },
              }}
            />
            <Typography
              sx={{
                ml: 1,
                fontSize: { md: "22px", sm: "18px" },
                color: "#03a300 !important",
                mt: "0 !important",
              }}
            >
              No need to maintain any Excel template. Whenever you wish to use
              it, just do it on cloud, quickly
            </Typography>
          </Box>
        </Box>
      </SectionFifteenWrapper>
      <Box
        sx={{
          mt: 10,
          width: "95%",
          mx: "auto",
          "& video": {
            maxWidth: "1536px",
            width: "100%",
            borderRadius: "12px",
            boxShadow: "4px 0px 20px 0px #66666640",
          },
        }}
      >
        <video src={Pharma1Video} autoPlay loop muted playsInline />
      </Box>
      <SectionSixteenWrapper>
        <Typography
          variant="h3"
          sx={{
            fontSize: { md: "40px", sm: "32px", xs: "28px" },
            fontWeight: 700,
            ml: { md: 8, sm: 5, xs: 1 },
            fontFamily: "Mohave",
            fontStyle: "italic",
            width: "fit-content",
            // borderBottom: "4px solid",
          }}
        >
          OTHER CHANGES MADE THROUGHOUT THE APPLICATION
        </Typography>
        <Grid
          container
          sx={{
            mt: { lg: 5 },
            display: { lg: "flex", xs: "none" },
            position: "relative",
          }}
          alignItems="flex-start"
          ref={IterationSection}
        >
          <Grid
            item
            lg={8.5}
            md={8}
            sx={{
              height: "70vh",
              position: "relative",
              "& img": {
                position: "absolute",
                width: "80%",
                height: "auto",
                right: "15%",
              },
            }}
          >
            {/* Arrows now inside the image container */}
            <Box
              sx={{
                position: "absolute",
                bottom: 20,
                right: "17%", // Aligns with images that have right: 15%
                zIndex: 25,
                display: "flex",
                gap: 2,
              }}
            >
              <Box
                onClick={handleLastSliderPrev}
                sx={{
                  cursor: "pointer",
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  backgroundColor: "#000",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s ease",
                  opacity:
                    currentSlideFromLastSlider.currentIndex === 0 ? 0.3 : 1,
                  pointerEvents:
                    currentSlideFromLastSlider.currentIndex === 0
                      ? "none"
                      : "auto",
                  border: "2px solid #F7F5F0",
                  "&:hover": {
                    backgroundColor: "#F7F5F0",
                    transform: "scale(1.1)",
                    "& svg": {
                      color: "#000",
                    },
                  },
                }}
              >
                <ChevronLeft sx={{ color: "#F7F5F0", fontSize: 36 }} />
              </Box>

              <Box
                onClick={handleLastSliderNext}
                sx={{
                  cursor: "pointer",
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  backgroundColor: "#000",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s ease",
                  opacity:
                    currentSlideFromLastSlider.currentIndex === 4 ? 0.3 : 1,
                  pointerEvents:
                    currentSlideFromLastSlider.currentIndex === 4
                      ? "none"
                      : "auto",
                  border: "2px solid #F7F5F0",
                  "&:hover": {
                    backgroundColor: "#F7F5F0",
                    transform: "scale(1.1)",
                    "& svg": {
                      color: "#000",
                    },
                  },
                }}
              >
                <ChevronRight sx={{ color: "#F7F5F0", fontSize: 36 }} />
              </Box>
            </Box>
            <img
              src={LastSlider1}
              style={{ zIndex: 15, bottom: 0 }}
              alt="No content"
              className={
                currentSlideFromLastSlider.currentIndex === 0
                  ? "active"
                  : currentSlideFromLastSlider.currentIndex >
                    currentSlideFromLastSlider.prevIndex
                  ? "deactive"
                  : ""
              }
            />
            <Box
              sx={{
                "& img": {
                  ...(currentSlideFromLastSlider.currentIndex >
                    currentSlideFromLastSlider.prevIndex &&
                  currentSlideFromLastSlider.currentIndex > 1
                    ? {
                        transition: "0.5s",
                        transform: "skewX(0deg) !important",
                        width: "80% !important",
                        bottom: 0,
                        right: "15% !important",
                        zIndex: 10,
                      }
                    : {
                        transform: "skewX(-5deg)",
                        width: "70%",
                        bottom: "20px",
                        right: { xl: "140px", lg: "120px" },
                        zIndex: 10,
                      }),
                },
              }}
            >
              <img
                src={LastSlider2}
                alt="No content"
                className={
                  currentSlideFromLastSlider.currentIndex === 1
                    ? "active"
                    : (currentSlideFromLastSlider.currentIndex >
                        currentSlideFromLastSlider.prevIndex ||
                        currentSlideFromLastSlider.prevIndex >
                          currentSlideFromLastSlider.currentIndex) &&
                      currentSlideFromLastSlider.currentIndex > 1
                    ? "deactive"
                    : currentSlideFromLastSlider.prevIndex >
                      currentSlideFromLastSlider.currentIndex
                    ? "reactive"
                    : ""
                }
              />
            </Box>
            <Box
              sx={{
                "& .reactive": {
                  transform: "skewX(-8deg) !important",
                  width: "68% !important",
                  bottom: "20px !important",
                  right: "13% !important",
                  zIndex: "5 !important",
                },
                "& img": {
                  ...(currentSlideFromLastSlider.currentIndex >
                    currentSlideFromLastSlider.prevIndex &&
                  currentSlideFromLastSlider.currentIndex > 2
                    ? {
                        transition: "0.5s",
                        transform: "skewX(0deg) !important",
                        width: "80% !important",
                        bottom: 0,
                        right: "15% !important",
                        zIndex: 5,
                      }
                    : {
                        transform: "skewX(-8deg)",
                        width: "67%",
                        bottom: "20px",
                        right: "13% !important",
                        zIndex: 5,
                      }),
                },
              }}
            >
              <img
                src={LastSlider3}
                alt="No content"
                className={
                  currentSlideFromLastSlider.currentIndex === 2
                    ? "active"
                    : (currentSlideFromLastSlider.currentIndex >
                        currentSlideFromLastSlider.prevIndex ||
                        currentSlideFromLastSlider.prevIndex >
                          currentSlideFromLastSlider.currentIndex) &&
                      currentSlideFromLastSlider.currentIndex > 2
                    ? "deactive"
                    : currentSlideFromLastSlider.prevIndex >
                      currentSlideFromLastSlider.currentIndex
                    ? "reactive"
                    : ""
                }
              />
            </Box>

            <Box
              sx={{
                "& .reactive": {
                  transform: "skewX(-12deg) !important",
                  width: "65% !important",
                  bottom: "20px !important",

                  right: "11% !important",
                  zIndex: "3 !important",
                },
                "& img": {
                  ...(currentSlideFromLastSlider.currentIndex >
                    currentSlideFromLastSlider.prevIndex &&
                  currentSlideFromLastSlider.currentIndex > 3
                    ? {
                        transition: "0.5s",
                        transform: "skewX(0deg) !important",
                        width: "80% !important",
                        bottom: 0,
                        right: "15% !important",
                        zIndex: 3,
                      }
                    : {
                        transform: "skewX(-12deg)",
                        width: "65%",
                        bottom: "10px",
                        right: "12% !important",
                        zIndex: 3,
                      }),
                },
              }}
            >
              <img
                src={LastSlider4}
                alt="No content"
                className={
                  currentSlideFromLastSlider.currentIndex === 3
                    ? "active"
                    : (currentSlideFromLastSlider.currentIndex >
                        currentSlideFromLastSlider.prevIndex ||
                        currentSlideFromLastSlider.prevIndex >
                          currentSlideFromLastSlider.currentIndex) &&
                      currentSlideFromLastSlider.currentIndex > 3
                    ? "deactive"
                    : currentSlideFromLastSlider.prevIndex >
                      currentSlideFromLastSlider.currentIndex
                    ? "reactive"
                    : ""
                }
              />
            </Box>
            <Box
              sx={{
                "& img": {
                  right: "95px !important",
                  zIndex: "0 !important",
                },
              }}
            >
              <img
                src={Pharma3GIF}
                alt="No content"
                style={{
                  transform: "skewX(-16deg)",
                  width: "63%",
                  bottom: "0",
                }}
                className={
                  currentSlideFromLastSlider.currentIndex === 4
                    ? "active"
                    : // : currentSlideFromLastSlider.currentIndex >
                    //   currentSlideFromLastSlider.prevIndex
                    // ? "deactive"
                    currentSlideFromLastSlider.prevIndex >
                      currentSlideFromLastSlider.currentIndex
                    ? "reactive"
                    : ""
                }
              />
            </Box>
          </Grid>
          <Grid
            item
            lg={3.5}
            md={4}
            xs={12}
            textAlign="center"
            position="relative"
            height="70vh"
          >
            {currentSlideFromLastSlider.currentIndex === 0 && (
              <>
                <SliderTracker>
                  <Typography>
                    {currentSlideFromLastSlider.currentIndex + 1}/5
                  </Typography>
                </SliderTracker>
                <Box
                  sx={{
                    position: "absolute",
                    top: "28%",
                    left: { xl: "-35%", lg: "-28%" },
                    zIndex: 20,
                  }}
                ></Box>
                <Box
                  sx={{
                    position: "absolute",
                    top: "37%",
                    left: "-5%",
                    width: "290px",
                    "& p": {
                      fontFamily: "Caveat",
                      fontSize: { md: "22px", sm: "18px" },
                    },
                  }}
                >
                  <Typography>
                    All data entry statuses now shown on top for quick view
                    (Role-based data)
                  </Typography>
                </Box>
                <Box
                  sx={{
                    py: 2.25,
                    px: 3,
                    position: "absolute",
                    top: "65%",
                    left: "-10%",
                    background: (theme: Theme) => theme.palette.secondary.main,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { lg: "20px", xs: "16px" },
                      fontWeight: 600,
                      width: "380px",
                      color: "#000",
                      textAlign: "center",
                    }}
                  >
                    Quick glance of KPI entry status
                  </Typography>
                </Box>
              </>
            )}
            {currentSlideFromLastSlider.currentIndex === 1 && (
              <>
                <SliderTracker>
                  <Typography>
                    {currentSlideFromLastSlider.currentIndex + 1}/5
                  </Typography>
                </SliderTracker>
                <Box
                  sx={{
                    position: "absolute",
                    top: "45%",
                    left: { xl: "-35%", lg: "-28%" },
                    zIndex: 20,
                  }}
                ></Box>
                <Box
                  sx={{
                    py: 2.25,
                    px: 3,
                    position: "absolute",
                    top: "17%",
                    left: "-5%",
                    background: (theme: Theme) => theme.palette.secondary.main,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { lg: "20px", xs: "16px" },
                      fontWeight: 600,
                      width: "380px",
                      color: "#000",
                    }}
                  >
                    Freeze moved from being a card on top, to just a button
                    (considering usage frequency)
                  </Typography>
                </Box>
                <Box
                  sx={{
                    position: "absolute",
                    top: "55%",
                    left: "-5%",
                    width: "340px",
                    "& p": {
                      fontFamily: "Caveat",
                      fontSize: { md: "22px", sm: "18px" },
                    },
                  }}
                >
                  <Typography>
                    Freeze added next to the table and not as a card on top
                    (since only 2-3 people use it, so having it as a card on top
                    isn’t good use of space)
                  </Typography>
                </Box>
              </>
            )}
            {currentSlideFromLastSlider.currentIndex === 2 && (
              <>
                <SliderTracker>
                  <Typography>
                    {currentSlideFromLastSlider.currentIndex + 1}/5
                  </Typography>
                </SliderTracker>
                <Box
                  sx={{
                    position: "absolute",
                    top: "42%",
                    left: { xl: "-35%", lg: "-28%" },
                    zIndex: 20,
                    transform: "rotateX(180deg)",
                  }}
                ></Box>
                <Box
                  sx={{
                    position: "absolute",
                    top: "25%",
                    left: "-5%",
                    width: "340px",
                    "& p": {
                      fontFamily: "Caveat",
                      fontSize: { md: "22px", sm: "18px" },
                    },
                  }}
                >
                  <Typography>
                    Table cleaned up by eliminating unnecessary columns (better
                    focus on what matters most at this point for the user)
                  </Typography>
                </Box>
                <Box
                  sx={{
                    py: 2.25,
                    px: 3,
                    position: "absolute",
                    top: "58%",
                    left: "-10%",
                    background: (theme: Theme) => theme.palette.secondary.main,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { lg: "20px", xs: "16px" },
                      fontWeight: 600,
                      width: "380px",
                      color: "#000",
                    }}
                  >
                    Data Owner & Last Modified By added at a place where it’s
                    the least distracting, with all imp. columns upfront
                  </Typography>
                </Box>
              </>
            )}
            {currentSlideFromLastSlider.currentIndex === 3 && (
              <>
                <SliderTracker>
                  <Typography>
                    {currentSlideFromLastSlider.currentIndex + 1}/5
                  </Typography>
                </SliderTracker>
                <Box
                  sx={{
                    position: "absolute",
                    top: "25%",
                    left: { xl: "-35%", lg: "-28%" },
                    zIndex: 20,
                  }}
                ></Box>
                <Box
                  sx={{
                    position: "absolute",
                    top: "35%",
                    left: "-5%",
                    width: "290px",
                    "& p": {
                      fontFamily: "Caveat",
                      fontSize: { md: "22px", sm: "18px" },
                    },
                  }}
                >
                  <Typography>
                    Global Search introduced with section-wise segregation
                  </Typography>
                </Box>
                <Box
                  sx={{
                    py: 2.25,
                    px: 3,
                    position: "absolute",
                    top: "60%",
                    left: "-10%",
                    background: (theme: Theme) => theme.palette.secondary.main,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { lg: "20px", xs: "16px" },
                      fontWeight: 600,
                      width: "380px",
                      color: "#000",
                    }}
                  >
                    Search with application-wide results segregation, to aid
                    easy finding of the desired keyword
                  </Typography>
                </Box>
              </>
            )}
            {currentSlideFromLastSlider.currentIndex === 4 && (
              <>
                <SliderTracker>
                  <Typography>
                    {currentSlideFromLastSlider.currentIndex + 1}/5
                  </Typography>
                </SliderTracker>
                <Box
                  sx={{
                    position: "absolute",
                    top: "25%",
                    left: { xl: "-35%", lg: "-28%" },
                    zIndex: 20,
                  }}
                ></Box>
                <Box
                  sx={{
                    position: "absolute",
                    top: "35%",
                    left: "-5%",
                    width: "290px",
                    "& p": {
                      fontFamily: "Caveat",
                      fontSize: { md: "22px", sm: "18px" },
                    },
                  }}
                >
                  <Typography>
                    Contextual information division in KPI Overview with
                    interactive chart and data drill-down
                  </Typography>
                </Box>
                <Box
                  sx={{
                    py: 2.25,
                    px: 3,
                    position: "absolute",
                    top: "60%",
                    left: "-10%",
                    background: (theme: Theme) => theme.palette.secondary.main,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { lg: "20px", xs: "16px" },
                      fontWeight: 600,
                      width: "380px",
                      color: "#000",
                    }}
                  >
                    KPI Overview as a flyout with grouped information and
                    data-intensive chart
                  </Typography>
                </Box>
              </>
            )}
          </Grid>
        </Grid>
        <Box
          sx={{
            display: { lg: "none", xs: "block" },
            width: "90%",
            mx: "auto",
            "& img": {
              width: "90%",
              mx: "auto",
            },
          }}
        >
          <Slider
            {...{
              dots: true,
              infinite: true,
              nextArrow: <ChevronRight color="primary" />,
              prevArrow: <ChevronLeft color="primary" />,
              arrows: true,
              speed: 250,
              slidesToShow: 1,
              slidesToScroll: 1,
            }}
          >
            <Grid container>
              <Grid item xs={12}>
                <img src={LastSlider1} alt="No content" />
              </Grid>
              <Grid item xs={12} textAlign="center">
                <>
                  <Box
                    sx={{
                      mt: 5,
                      width: "100%",
                      "& p": {
                        fontFamily: "Caveat",
                        fontSize: { md: "22px", sm: "18px" },
                      },
                    }}
                  >
                    <Typography>
                      All data entry statuses now shown on top for quick view
                      (Role-based data)
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      py: 2.25,
                      px: 3,
                      mt: 5,
                      mx: "auto",
                      width: "fit-content",
                      background: (theme: Theme) =>
                        theme.palette.secondary.main,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { lg: "20px", xs: "16px" },
                        fontWeight: 600,
                        width: "fit-content",
                        color: "#000",
                        textAlign: "center",
                      }}
                    >
                      Quick glance of KPI entry status
                    </Typography>
                  </Box>
                </>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12}>
                <img src={LastSlider2} alt="No content" />
              </Grid>
              <Grid item xs={12} textAlign="center">
                <>
                  <Box
                    sx={{
                      mt: 5,
                      width: "100%",
                      "& p": {
                        fontFamily: "Caveat",
                        fontSize: { md: "22px", sm: "18px" },
                      },
                    }}
                  >
                    <Typography>
                      Freeze moved from being a card on top, to just a button
                      (considering usage frequency)
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      py: 2.25,
                      px: 3,
                      mt: 5,
                      mx: "auto",
                      width: "fit-content",
                      background: (theme: Theme) =>
                        theme.palette.secondary.main,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { lg: "20px", xs: "16px" },
                        fontWeight: 600,
                        width: "fit-content",
                        color: "#000",
                        textAlign: "center",
                      }}
                    >
                      Freeze added next to the table and not as a card on top
                      (since only 2-3 people use it, so having it as a card on
                      top isn’t good use of space)
                    </Typography>
                  </Box>
                </>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12}>
                <img src={LastSlider3} alt="No content" />
              </Grid>
              <Grid item xs={12} textAlign="center">
                <>
                  <Box
                    sx={{
                      mt: 5,
                      width: "100%",
                      "& p": {
                        fontFamily: "Caveat",
                        fontSize: { md: "22px", sm: "18px" },
                      },
                    }}
                  >
                    <Typography>
                      Table cleaned up by eliminating unnecessary columns
                      (better focus on what matters most at this point for the
                      user)
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      py: 2.25,
                      px: 3,
                      mt: 5,
                      mx: "auto",
                      width: "fit-content",
                      background: (theme: Theme) =>
                        theme.palette.secondary.main,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { lg: "20px", xs: "16px" },
                        fontWeight: 600,
                        width: "fit-content",
                        color: "#000",
                        textAlign: "center",
                      }}
                    >
                      Data Owner & Last Modified By added at a place where it’s
                      the least distracting, with all imp. columns upfront
                    </Typography>
                  </Box>
                </>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12}>
                <img src={LastSlider4} alt="No content" />
              </Grid>
              <Grid item xs={12} textAlign="center">
                <>
                  <Box
                    sx={{
                      mt: 5,
                      width: "100%",
                      "& p": {
                        fontFamily: "Caveat",
                        fontSize: { md: "22px", sm: "18px" },
                      },
                    }}
                  >
                    <Typography>
                      Global Search introduced with section-wise segregation
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      py: 2.25,
                      px: 3,
                      mt: 5,
                      mx: "auto",
                      width: "fit-content",
                      background: (theme: Theme) =>
                        theme.palette.secondary.main,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { lg: "20px", xs: "16px" },
                        fontWeight: 600,
                        width: "fit-content",
                        color: "#000",
                        textAlign: "center",
                      }}
                    >
                      Search with application-wide results segregation, to aid
                      easy finding of the desired keyword
                    </Typography>
                  </Box>
                </>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12}>
                <img src={Pharma3GIF} alt="No content" />
              </Grid>
              <Grid item xs={12} textAlign="center">
                <>
                  <Box
                    sx={{
                      mt: 5,
                      width: "100%",
                      "& p": {
                        fontFamily: "Caveat",
                        fontSize: { md: "22px", sm: "18px" },
                      },
                    }}
                  >
                    <Typography>
                      KPI Overview as a flyout with grouped information and
                      data-intensive chart
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      py: 2.25,
                      px: 3,
                      mt: 5,
                      mx: "auto",
                      width: "fit-content",
                      background: (theme: Theme) =>
                        theme.palette.secondary.main,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { lg: "20px", xs: "16px" },
                        fontWeight: 600,
                        width: "fit-content",
                        color: "#000",
                        textAlign: "center",
                      }}
                    >
                      Contextual information division in KPI Overview with
                      interactive chart and data drill-down
                    </Typography>
                  </Box>
                </>
              </Grid>
            </Grid>
          </Slider>
        </Box>
      </SectionSixteenWrapper>
      <SectionSeventeenWrapper id="section4">
        <Typography
          variant="h3"
          sx={{
            fontSize: { md: "40px", sm: "32px", xs: "28px" },
            fontWeight: 700,
            fontFamily: "Mohave",
            fontStyle: "italic",
            width: "fit-content",
            // borderBottom: "4px solid",
          }}
        >
          IMPACT
        </Typography>

        <Typography
          sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 600 }}
        >
          −85% data-entry time · Non-existent overwrite incidents
        </Typography>
        <Box
          sx={{
            py: 3.5,
            px: 4,
            mt: 4,
            background: (theme: Theme) => theme.palette.secondary.main,
          }}
        >
          <Typography
            sx={{
              fontSize: { md: "28px", xs: "22px" },
              fontWeight: 600,
              lineHeight: "33.89px",
              color: "#000",
            }}
          >
            Accurate, on-time KPI entry meant planning teams could trust the
            data driving their decisions, reducing the risk of supply chain
            disruptions caused by corrupted inputs.
          </Typography>
        </Box>
        <Box sx={{ mt: 10 }}>
          <Box
            sx={{
              width: { lg: "640px", xs: "100%" },
              px: 3,
              py: 3.5,
              background: (theme: Theme) => theme.palette.secondary.main,
            }}
          >
            <Typography
              sx={{ fontSize: "24px", fontWeight: 600, color: "#000" }}
            >
              "The new UI really makes our jobs much easier. You guys did an
              amazing job, thank you!
            </Typography>
          </Box>
          <Box
            sx={{
              width: { lg: "640px", xs: "100%" },
              pl: 3,
              pr: 1,
              py: 1.5,
              background: "#000",
            }}
          >
            <Typography
              sx={{
                fontSize: { lg: "20px", xs: "16px" },
                fontWeight: 400,
                color: (theme: Theme) => theme.palette.secondary.main,
              }}
            >
              -Name is confidential, Director, Global Strategy & Deployment
            </Typography>
          </Box>
          <Box sx={{ ml: 6, mt: -1 }}>
            <ToolTipIcons />
          </Box>
          <Box sx={{ mt: 3 }}>
            <img src={User1} alt="no user" />
          </Box>
        </Box>
        <Box
          sx={{
            top: { lg: "60%", xs: "80%" },
            position: { lg: "absolute" },
            right: 0,
          }}
        >
          <Box
            sx={{
              width: { lg: "640px", xs: "100%" },
              px: 3,
              py: 3.5,
              mt: { lg: 0, xs: 5 },
              background: (theme: Theme) => theme.palette.secondary.main,
            }}
          >
            <Typography
              sx={{ fontSize: "24px", fontWeight: 600, color: "#000" }}
            >
              "Tasks that earlier took me about 30 minutes to complete, now will
              probably take only 5 minutes!"
            </Typography>
          </Box>
          <Box
            sx={{
              width: { lg: "640px", xs: "100%" },
              pl: 3,
              pr: 1,
              py: 1.5,
              background: "#000",
            }}
          >
            <Typography
              sx={{
                fontSize: { lg: "20px", xs: "16px" },
                fontWeight: 400,
                color: (theme: Theme) => theme.palette.secondary.main,
              }}
            >
              -Name is confidential, Manager, Data Excellence
            </Typography>
          </Box>
          <Box sx={{ mr: 6, mt: -1, textAlign: "right" }}>
            <ToolTipIcons />
          </Box>
          <Box sx={{ mt: 3, textAlign: "right" }}>
            <img src={User2} alt="no user" />
          </Box>
        </Box>
      </SectionSeventeenWrapper>

      <SectionEighteenWrapper
        sx={{
          "& div": {
            overflowX: "visible !important",
            zIndex: 0,
          },
          "&>div:hover": {
            zIndex: 1,
          },
        }}
      >
        <Box
          onMouseEnter={() => setIsPlaying(false)}
          onMouseLeave={() => setIsPlaying(true)}
          sx={{ my: 3 }}
        >
          <Marquee play={isPlaying} gradient={false} speed={50}>
            <img src={Image1} alt="No Info" />

            <img src={Image2} alt="No Info" />

            <img src={Image3} alt="No Info" />

            <img src={Image4} alt="No Info" />
          </Marquee>
        </Box>
        <Box
          onMouseEnter={() => setIsPlaying(false)}
          onMouseLeave={() => setIsPlaying(true)}
          sx={{ my: 3 }}
        >
          <Marquee
            play={isPlaying}
            gradient={false}
            speed={50}
            direction="right"
          >
            <img src={Image5} alt="No Info" />

            <img src={Image6} alt="No Info" />

            <img src={Image7} alt="No Info" />

            <img src={Image8} alt="No Info" />
          </Marquee>
        </Box>
        <Box
          onMouseEnter={() => setIsPlaying(false)}
          onMouseLeave={() => setIsPlaying(true)}
          sx={{ my: 3 }}
        >
          <Marquee play={isPlaying} gradient={false} speed={50}>
            <img src={Image9} alt="No Info" />

            <img src={Image10} alt="No Info" />

            <img src={Image11} alt="No Info" />

            <img src={Image12} alt="No Info" />

            <img src={Image13} alt="No Info" />
          </Marquee>
        </Box>
      </SectionEighteenWrapper>
    </ProjectWrapper>
  );
};

export default withAuth(Project);